import { h, Host, Component, Prop } from '@stencil/core';

export interface QwSkeletonData {
  qwRepeat: number;
  qwWidth: string;
  qwHeight: string;
  qwType: string;
}

@Component({
  tag: 'qw-skeleton',
  styleUrl: 'qw-skeleton.scss',
  shadow: false,
})
export class QwSkeletonInjector {
  @Prop() qwData: Array<QwSkeletonData>;
  @Prop() classLayout?: string;

  public htmlData(element, limiter) {
    let skeletonElements = [];
    for (let i = 0; i < limiter; i++) {
      skeletonElements.push(
        <span
          {...{ type: element.qwType }}
          style={{ width: element.qwWidth, height: element.qwHeight }}
        ></span>,
      );
    }
    return skeletonElements;
  }

  render() {
    return (
      <Host>
        {this.qwData.map((element) => {
          let numberOfElements = element.qwRepeat || 1;
          return this.htmlData(element, numberOfElements);
        })}
      </Host>
    );
  }
}
